import { authHeader, BASE_URL, handleResponse } from '@helpers/api';
import { ProductEvent } from '@constants/product-events';
import { captureOnSuccess } from '@helpers/product-events';

function getTeams(search) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/teams?search=${encodeURIComponent(search || '')}`, requestOptions)
        .then(handleResponse)
        .then(data => data?.items || []);
}

function getTeam(teamId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/teams/${teamId}`, requestOptions).then(handleResponse);
}

function createTeam(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(`${BASE_URL}api/teams`, requestOptions)
        .then(handleResponse)
        .then(captureOnSuccess(ProductEvent.TeamCreated, { source: 'new' }));
}

function updateTeam(teamId, data) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(`${BASE_URL}api/teams/${teamId}`, requestOptions).then(handleResponse);
}

function deleteTeam(teamId) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/teams/${teamId}`, requestOptions).then(handleResponse);
}

function duplicateTeam(teamId, data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(`${BASE_URL}api/teams/${teamId}/duplicate`, requestOptions)
        .then(handleResponse)
        .then(captureOnSuccess(ProductEvent.TeamCreated, { source: 'duplicate' }));
}

function getPermissionsCatalog() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/permissions`, requestOptions).then(handleResponse);
}

export const teamsService = {
    getTeams,
    getTeam,
    createTeam,
    updateTeam,
    deleteTeam,
    duplicateTeam,
    getPermissionsCatalog,
};
